import * as React from 'react';
import { cn } from './lib/utils';

/**
 * Standardized empty state for lists, panels, and tables.
 *
 * <EmptyState
 *   icon={<Inbox className="h-8 w-8" />}
 *   title="No interventions"
 *   body="Assign a signal to get started."
 *   action={<Button variant="primary" size="sm">Add Signal</Button>}
 * />
 *
 * size="sm"  — compact, icon at 24px, used inside cards
 * size="md"  — default, icon at 32px, used in panel content areas
 * size="lg"  — full-page, icon at 48px, padded generously
 */

const SIZE = {
  sm: { wrap: 'py-8 px-4',  icon: 'h-6 w-6 mb-2', title: 'text-[13px] font-semibold', body: 'text-[12px] mt-0.5' },
  md: { wrap: 'py-14 px-5', icon: 'h-8 w-8 mb-3', title: 'text-[15px] font-semibold', body: 'text-[13px] mt-1'   },
  lg: { wrap: 'py-20 px-8', icon: 'h-12 w-12 mb-4',title: 'text-[17px] font-semibold', body: 'text-[14px] mt-1.5'},
};

function EmptyState({ icon, title, body, action, size = 'md', className }) {
  const s = SIZE[size] ?? SIZE.md;

  return (
    <div className={cn('flex flex-col items-center text-center', s.wrap, className)}>
      {icon && (
        <span className={cn('text-text-muted', s.icon)}>
          {icon}
        </span>
      )}
      {title && (
        <p className={cn(s.title, 'text-text-dark')}>{title}</p>
      )}
      {body && (
        <p className={cn(s.body, 'text-text-dark-secondary max-w-[280px]')}>{body}</p>
      )}
      {action && (
        <div className="mt-4">{action}</div>
      )}
    </div>
  );
}

export { EmptyState };
